const list = []
export const echartTemp  = [
  {
    color: ['#EAEA26', '#906BF9', '#FE5656', '#01E17E', '#3DD1F9', '#FFAD05'],
    grid: {
      left: 500,
      top: 50,
      bottom: 10,
      right: 10,
      containLabel: true,
    },
    polar: {},
    angleAxis: {
      interval: 1,
      type: 'category',
      data: [],
      z: 10,
      axisLine: {
        show: false,
        lineStyle: {
          color: '#0B4A6B',
          width: 0,
          type: 'solid',
        },
      },
      axisLabel: {
        show: false,
        interval: 0,
        
        color: '#0B4A6B',
        margin: 8,
        fontSize: 16,
      },
    },
    radiusAxis: {
      interval: 20,
      axisLine :{
        show:false
      },
      axisLabel: {
        formatter: '{value} %',
        show: false,
        padding: [0, 0, 20, 0],
        color: '#0B3E5E',
        fontSize: 16,
      },
      splitLine: {
        lineStyle: {
          color: '#F1F8FF',
          width: 0,
          type: 'solid',
        },
      },
    },
    calculable: true,
    series: [
      {
        type: 'pie',
        radius: ['17%', '18%'],
        hoverAnimation: false,
        labelLine: {
          normal: {
            show: false,
            length: 30,
            length2: 55,
          },
        },
        data: [
          {
            name: '',
            value: 0,
            itemStyle: {
              normal: {
                color: '#B5CCE7',
              },
            },
            tooltip:{
              show:false
            }
          },
        ],
      },
      {
        type: 'pie',
        radius: ['70%', '72%'],
        hoverAnimation: false,
        itemStyle: {
          normal: {
          color: 'transparent',  // 颜色设为透明
          borderWidth: 0,
          },
        },
        labelLine: { normal: { show: false } },
        data: [{
          name: '',
          value: 0,
          tooltip: { show: false }
        }]
      },
      {
        stack: 'a',
        type: 'pie',
        radius: ['20%', '60%'],
        roseType: 'area',
        zlevel: 10,
        label: {
          normal: {
            show: true,
            formatter: function (param) {
              return '{a|' + param.name + '}\n\n' + '{b|' + param.value+ '}';
            },
            textStyle: {
              fontSize: 12,
            },
            rich: {
              a: {
                color: '#666666',
                fontSize: '12',
              },
              b: {
                color: '#ff0000',
                fontSize: '12',
              },
              
            },
            position: 'outside',
          },
          emphasis: {
            show: true,
          },
        },
        itemStyle: {
          normal: {
            color: '#f00'
          },
        },
        labelLine: {
          normal: {
            show: true,
            length: 10,
            length2: 30,
            color:'#4BCFFC'
          },
          emphasis: {
            show: true,
          },
        },
        data: list,
      },
    ],
  },
];